exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProfileIcon__root--3kRUa{width:18px;height:18px}", ""]);

// exports
exports.locals = {
	"root": "ProfileIcon__root--3kRUa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/components/Library/ProfileIcon/ProfileIcon.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/components/Library/ProfileIcon/ProfileIcon.css
// module chunks = 1